import ruby from '../../assets/OneWorld_Ruby.png';
import sapphire from '../../assets/OneWorld_Sapphire.png';
import emerald from '../../assets/OneWorld_Emerald.png';
import baBlue from '../../assets/BA_Blue.png';
import baBronze from '../../assets/BA_Bronze.png';
import baSilver from '../../assets/BA_Silver.png';
import baGold from '../../assets/BA_Gold.png';
import ayBasic from '../../assets/Finnair_Basic.png';
import aySilver from '../../assets/Finnair_Silver.png';
import ayGold from '../../assets/Finnair_Gold.png';
import ayPlatinum from '../../assets/Finnair_Platinum.png';
import ayLumo from '../../assets/Finnair_Platinum_Lumo.png';

/** First-party artwork only; provenance lives in public/assets/airlines/README.md. */
export const BUNDLED_AIRLINE_CODES = ['BA', 'AY', 'CX', 'FJ', 'JL', 'QF', 'QR'] as const;
export function bundledAirlineArtwork(code: string | null | undefined): string | undefined {
  const normalized = code?.trim().toUpperCase();
  return BUNDLED_AIRLINE_CODES.some(value => value === normalized) ? `/assets/airlines/${normalized}.png` : undefined;
}
export const ONEWORLD_ARTWORK = { Ruby: ruby, Sapphire: sapphire, Emerald: emerald };
export const PROGRAMME_TIER_ARTWORK: Record<string, Record<string, string>> = {
  BA: { Blue: baBlue, Bronze: baBronze, Silver: baSilver, Gold: baGold },
  AY: { Basic: ayBasic, Silver: aySilver, Gold: ayGold, Platinum: ayPlatinum, 'Platinum Lumo': ayLumo },
};
/** Artwork is a display lookup, never a membership/alliance eligibility calculation. */
export function programmeTierArtwork(carrier: string | null | undefined, tier: string): string | undefined {
  return carrier ? PROGRAMME_TIER_ARTWORK[carrier.toUpperCase()]?.[tier] : undefined;
}
